// extracted by mini-css-extract-plugin
module.exports =  {"messageWrapper":"messageWrapper___hIKdw","title":"title___SbJcS","text":"text___1CieI"};